var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activation-email-list"},[_c('ActivationEmailItem',{attrs:{"email":_vm.email},on:{"toggle-change":function($event){return _vm.$emit('handle-change-enabled')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }